<template>
	<el-dialog title="添加好友" :visible.sync="dialogVisible" width="500px" :before-close="onClose"
		custom-class="add-friend-dialog" :modal="false">

		<!-- 搜索方式选项卡 -->
		<el-tabs v-model="searchMode" type="card" @tab-click="onTabChange">
			<!-- 按用户名/昵称搜索 -->
			<el-tab-pane label="用户名/昵称" name="byName">
				<el-input placeholder="输入用户名或昵称按下enter搜索，最多展示20条" class="input-with-select" v-model="searchText" size="small"
					@keyup.enter.native="onSearch()">
					<i class="el-icon-search el-input__icon" slot="suffix" @click="onSearch()"> </i>
				</el-input>
			</el-tab-pane>

			<!-- 按手机号搜索 -->
			<el-tab-pane label="手机号" name="byPhone">
				<el-input placeholder="输入手机号按下enter搜索" class="input-with-select" v-model="phoneSearchText" size="small"
					@keyup.enter.native="onSearch()">
					<i class="el-icon-search el-input__icon" slot="suffix" @click="onSearch()"> </i>
				</el-input>
			</el-tab-pane>
		</el-tabs>

		<!-- 搜索结果列表 -->
		<el-scrollbar style="height:400px">
			<div v-if="loading" class="loading-container">
				<el-loading :active="loading" :lock="false"></el-loading>
			</div>
			<div v-else-if="users.length === 0 && searchPerformed" class="no-results">
				<p>暂无搜索结果</p>
			</div>
			<div v-else>
				<div v-for="(user) in users" :key="user.id" v-show="user.id != $store.state.userStore.userInfo.id">
					<div class="item">
						<div class="avatar">
							<head-image :name="user.nickName" :url="user.headImage" :online="user.online"></head-image>
						</div>
						<div class="add-friend-text">
							<div class="nick-name">
								<div>{{ user.nickName }}</div>
								<div :class="user.online ? 'online-status  online' : 'online-status'">{{
									user.online ? "[在线]" :"[离线]"}}</div>
							</div>
							<div class="user-name">
								<div>用户名:{{ user.userName }}</div>
							</div>
							<div class="user-phone" v-if="user.phone">
								<div>手机号:{{ user.phone }}</div>
							</div>
						</div>
						<el-button type="success" size="mini" v-show="!isFriend(user.id)"
							@click="onAddFriend(user)">添加</el-button>
						<el-button type="info" size="mini" v-show="isFriend(user.id)" plain disabled>已添加</el-button>
					</div>
				</div>
			</div>
		</el-scrollbar>
	</el-dialog>
</template>

<script>
import HeadImage from '../common/HeadImage.vue'

export default {
	name: "addFriend",
	components: { HeadImage },
	data() {
		return {
			users: [],
			searchText: "",
			phoneSearchText: "",
			searchMode: "byName",  // byName 或 byPhone
			loading: false,
			searchPerformed: false
		}
	},
	props: {
		dialogVisible: {
			type: Boolean
		}
	},
	methods: {
		onTabChange() {
			// 切换标签页时清空搜索结果和搜索文本
			this.users = [];
			this.searchText = "";
			this.phoneSearchText = "";
			this.searchPerformed = false;
		},

		onClose() {
			this.users = [];
			this.searchText = "";
			this.phoneSearchText = "";
			this.searchPerformed = false;
			this.$emit("close");
		},

		onSearch() {
			let searchValue = "";

			if (this.searchMode === "byName") {
				searchValue = this.searchText.trim();
				if (!searchValue) {
					this.users = [];
					this.searchPerformed = false;
					return;
				}
			} else if (this.searchMode === "byPhone") {
				searchValue = this.phoneSearchText.trim();
				if (!searchValue) {
					this.users = [];
					this.searchPerformed = false;
					return;
				}
				// 验证手机号格式（中国手机号）
				if (!/^1[3-9]\d{9}$/.test(searchValue)) {
					this.$message.warning("请输入有效的手机号（11位）");
					return;
				}
			}

			this.searchPerformed = true;
			this.loading = true;

			const requestConfig = this.searchMode === "byName"
				? {
					url: "/user/findByName",
					method: "get",
					params: { name: searchValue }
				}
				: {
					url: "/user/findByPhone",
					method: "get",
					params: { phone: searchValue }
				};

			this.$http(requestConfig)
				.then((data) => {
					this.users = data || [];
					if (this.users.length === 0) {
						this.$message.info("未找到符合条件的用户");
					}
				})
				.catch((error) => {
					console.error("搜索失败:", error);
					this.$message.error("搜索失败，请稍后重试");
					this.users = [];
				})
				.finally(() => {
					this.loading = false;
				});
		},

		onAddFriend(user) {
			this.$http({
				url: "/friend/add",
				method: "post",
				params: {
					friendId: user.id
				}
			}).then((res) => {
				if (res && res.status === "PENDING") {
					this.$message.info("已发送好友申请，等待对方验证");
					return;
				}
				this.$message.success("添加成功，对方已成为您的好友");
				let friend = {
					id: user.id,
					nickName: user.nickName,
					headImage: user.headImage,
					online: user.online,
					deleted: false
				}
				this.$store.commit("addFriend", friend);

				// 从搜索结果中移除已添加的用户
				this.users = this.users.filter(u => u.id !== user.id);
			}).catch((error) => {
				console.error("添加好友失败:", error);
				this.$message.error("添加好友失败，请稍后重试");
			});
		},

		isFriend(userId) {
			return this.$store.getters.isFriend(userId);
		}
	}
}
</script>

<style lang="scss">
.add-friend-dialog {
	.el-tabs {
		margin-bottom: 15px;
	}

	.loading-container {
		height: 400px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.no-results {
		height: 400px;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #909399;
		font-size: 14px;
	}

	.item {
		height: 75px;
		display: flex;
		position: relative;
		padding-left: 15px;
		align-items: center;
		padding-right: 25px;
		border-bottom: 1px solid #f0f0f0;
		transition: background-color 0.2s;

		&:hover {
			background-color: #f5f7fa;
		}

		.add-friend-text {
			margin-left: 15px;
			flex: 3;
			display: flex;
			flex-direction: column;
			flex-shrink: 0;
			overflow: hidden;

			.nick-name {
				display: flex;
				flex-direction: row;
				font-weight: 600;
				font-size: 16px;
				line-height: 25px;

				.online-status {
					font-size: 12px;
					font-weight: 600;
					margin-left: 8px;

					&.online {
						color: #5fb878;
					}
				}
			}

			.user-name {
				display: flex;
				flex-direction: row;
				font-size: 12px;
				line-height: 20px;
				color: #606266;
			}

			.user-phone {
				display: flex;
				flex-direction: row;
				font-size: 12px;
				line-height: 20px;
				color: #909399;
			}

		}
	}
}
</style>
